const config = {
  apiUrl: 'https://api.thenikeyard.com',
  // apiUrl: 'http://127.0.0.1:4400',
  stravaApiUrl: 'https://www.strava.com/api/v3',
  athleteLogged: 'athleteLogged',
  clientID: '109277',
  clientSecret: '9b87056bb6764464d7aece7139f1384164125936',
  requestCallback: 'https://app.thenikeyard.com',
  // requestCallback: 'http://localhost:3000',
};

export default config;
